import React, { useEffect, useState } from "react";
import Title from "../../extra/Title";
import Button from "../../extra/Button";
import Pagination from "../../extra/Pagination";
import { useDispatch, useSelector } from "react-redux";
import { OPEN_DIALOGUE } from "../../store/dialogue/dialogue.type";
import SourcingRequestDialog from "./SourcingRequestDialog";
import {
  getSourcingRequests,
  deleteSourcingRequest,
} from "../../store/sourcingRequest/sourcingRequest.action";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import dayjs from "dayjs";

const SourcingRequest = () => {
  const dispatch = useDispatch();
  const { sourcingRequests } = useSelector((state) => state.sourcingRequest);
  const { dialogue, dialogueType } = useSelector((state) => state.dialogue);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [isLoading, setIsLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState("");

  useEffect(() => {
    dispatch(getSourcingRequests(statusFilter));
    setTimeout(() => {
      setIsLoading(false);
    }, 1500);
  }, [dispatch, statusFilter]);

  useEffect(() => {
    setData(sourcingRequests);
  }, [sourcingRequests]);

  const handleOpenDialog = (data) => {
    // The dialogue reducer reads `payload.data` — passing the raw row as
    // `payload` left dialogueData null (blank dialog). Wrap it correctly.
    dispatch({ type: OPEN_DIALOGUE, payload: { type: "sourcingRequest", data } });
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this request?")) {
      dispatch(deleteSourcingRequest(id));
    }
  };

  const indexOfLastPost = currentPage * rowsPerPage;
  const indexOfFirstPost = indexOfLastPost - rowsPerPage;
  const currentPosts = data.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const getStatusBadge = (status) => {
    const badges = {
      Pending: "bg-warning text-dark",
      "In Progress": "bg-info",
      Quoted: "bg-primary",
      Accepted: "bg-success",
      Paid: "bg-success",
      Rejected: "bg-danger",
    };
    return badges[status] || "bg-secondary";
  };

  const getUrgencyBadge = (urgency) => {
    const badges = {
      Standard: "bg-secondary",
      Sea: "bg-info",
      Air: "bg-primary",
      Express: "bg-danger",
    };
    return badges[urgency] || "bg-secondary";
  };

  return (
    <>
      <div className="mainCategory">
        <Title name="Sourcing Requests" />

        {/* Filter */}
        <div className="row mb-3 mt-3">
          <div className="col-12 col-md-4">
            <select
              className="form-control"
              value={statusFilter}
              onChange={(e) => {
                setStatusFilter(e.target.value);
                setCurrentPage(1);
              }}
              style={{
                backgroundColor: "#2d2d2d",
                color: "white",
                border: "1px solid #444",
                padding: "10px",
              }}
            >
              <option value="">All Status</option>
              <option value="Pending">Pending</option>
              <option value="In Progress">In Progress</option>
              <option value="Quoted">Quoted</option>
              <option value="Accepted">Accepted</option>
              <option value="Paid">Paid</option>
              <option value="Rejected">Rejected</option>
            </select>
          </div>
          <div className="col-12 col-md-4 d-flex align-items-center">
            <span className="text-white">
              Total: <strong>{data.length}</strong> requests
            </span>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-12 mt-3">
            <div className="customTable">
              <div className="primeMain">
                <table width="100%" className="primeTable text-center">
                  <thead
                    className="sticky-top"
                    style={{ top: "-1px", zIndex: "1" }}
                  >
                    <tr>
                      <th className="fw-bold py-3" style={{ width: "3%" }}>
                        No
                      </th>
                      <th className="fw-bold py-3" style={{ width: "8%" }}>
                        Date
                      </th>
                      <th className="fw-bold py-3" style={{ width: "12%" }}>
                        Customer
                      </th>
                      <th className="fw-bold py-3" style={{ width: "15%" }}>
                        Product
                      </th>
                      <th className="fw-bold py-3" style={{ width: "8%" }}>
                        Category
                      </th>
                      <th className="fw-bold py-3" style={{ width: "10%" }}>
                        Budget
                      </th>
                      <th className="fw-bold py-3" style={{ width: "5%" }}>
                        Qty
                      </th>
                      <th className="fw-bold py-3" style={{ width: "7%" }}>
                        Urgency
                      </th>
                      <th className="fw-bold py-3" style={{ width: "8%" }}>
                        Images
                      </th>
                      <th className="fw-bold py-3" style={{ width: "8%" }}>
                        Status
                      </th>
                      <th className="fw-bold py-3" style={{ width: "10%" }}>
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <>
                        {Array.from({ length: 10 }).map((_, index) => (
                          <tr key={index}>
                            {Array.from({ length: 11 }).map((_, i) => (
                              <td key={i}>
                                <Skeleton />
                              </td>
                            ))}
                          </tr>
                        ))}
                      </>
                    ) : (
                      <>
                        {currentPosts.length > 0 ? (
                          <>
                            {currentPosts.map((item, index) => (
                              <tr key={index}>
                                <td className="text-white">
                                  {indexOfFirstPost + index + 1}
                                </td>
                                <td>
                                  <div
                                    style={{ fontSize: "12px" }}
                                    className="text-white"
                                  >
                                    {dayjs(item?.createdAt).format("DD/MM/YY")}
                                    <br />
                                    <span className="text-muted">
                                      {dayjs(item?.createdAt).format("HH:mm")}
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  <div
                                    style={{ fontSize: "12px" }}
                                    className="text-white"
                                  >
                                    <strong>{item?.fullName}</strong>
                                    <br />
                                    <span className="text-muted">
                                      {item?.whatsappNumber}
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      maxWidth: "180px",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                    }}
                                    className="text-white"
                                    title={item?.productName}
                                  >
                                    {item?.productName}
                                  </div>
                                </td>
                                <td className="text-white" style={{ fontSize: "12px" }}>
                                  {item?.category?.name || "-"}
                                </td>
                                <td className="text-white" style={{ fontSize: "12px" }}>
                                  {item?.budgetMin} - {item?.budgetMax}
                                </td>
                                <td className="text-white">{item?.quantity}</td>
                                <td>
                                  <span
                                    className={`badge ${getUrgencyBadge(
                                      item?.urgency
                                    )}`}
                                  >
                                    {item?.urgency}
                                  </span>
                                </td>
                                <td>
                                  {item?.images && item.images.length > 0 ? (
                                    <div className="d-flex justify-content-center gap-1">
                                      {item.images.slice(0, 2).map((img, i) => (
                                        <img
                                          key={i}
                                          src={img}
                                          alt=""
                                          style={{
                                            width: "30px",
                                            height: "30px",
                                            objectFit: "cover",
                                            borderRadius: "4px",
                                          }}
                                        />
                                      ))}
                                      {item.images.length > 2 && (
                                        <span className="text-muted" style={{ fontSize: "11px" }}>
                                          +{item.images.length - 2}
                                        </span>
                                      )}
                                    </div>
                                  ) : (
                                    <span className="text-muted">-</span>
                                  )}
                                </td>
                                <td>
                                  <span
                                    className={`badge ${getStatusBadge(
                                      item?.status
                                    )}`}
                                  >
                                    {item?.status}
                                  </span>
                                </td>
                                <td>
                                  <div className="d-flex justify-content-center gap-2">
                                    <Button
                                      newClass="boxCenter userBtn fs-5 text-white"
                                      btnColor="bg-primary"
                                      btnIcon="fa-solid fa-eye"
                                      onClick={() => handleOpenDialog(item)}
                                      style={{ borderRadius: "5px" }}
                                    />
                                    <Button
                                      newClass="boxCenter userBtn fs-5 text-white"
                                      btnColor="bg-danger"
                                      btnIcon="fa-solid fa-trash"
                                      onClick={() => handleDelete(item?._id)}
                                      style={{ borderRadius: "5px" }}
                                    />
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </>
                        ) : (
                          <tr>
                            <td colSpan="11" className="text-center text-white">
                              No Sourcing Requests Found
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            {/* Was wired with props the shared control does not have
                (totalPosts/paginate/currentPage), so it never rendered and only
                the first page of rows was reachable (2026-09-30). */}
            <Pagination
              component="div"
              type={"client"}
              count={data.length}
              totalData={data.length}
              serverPage={currentPage - 1}
              serverPerPage={rowsPerPage}
              onPageChange={(_e, p) => setCurrentPage(p + 1)}
              onRowsPerPageChange={(v) => {
                setRowsPerPage(parseInt(v, 10) || 25);
                setCurrentPage(1);
              }}
              rowsPerPageOptions={[25, 50, 100, 500]}
            />
          </div>
        </div>
      </div>
      {/* only this page's dialog, not e.g. the header Notification one */}
      {dialogue && dialogueType === "sourcingRequest" && <SourcingRequestDialog />}
    </>
  );
};

export default SourcingRequest;
